module.exports = __webpack_public_path__ + "assets/16ce848e007b1861982381fa663d56b0.mp3";